/* fileConstants.js */

"use strict";
const { OS_IMAGE_STATUS: _OS_IMAGE_STATUS } = require("@gluenetworks/platform-sdk-remote").entities.ws.OsImage;

const OS_IMAGE_STATUS = Object.assign({}, _OS_IMAGE_STATUS, {
    FAILED: "FAILED",
    ABORTED: "ABORTED"
});

const IMAGE_TYPES_FILTER = {
    ASDM: {
        name: "ASDM",
        title: "ASDM"
    },
    NXOS: {
        name: "NXOS",
        title: "NXOS Kickstart"
    },
    OS: {
        name: "OS",
        title: "OS Image"
    },
    ROMMON: {
        name: "ROMMON",
        title: "ROMMON"
    }
};

//TODO Quick fix below to be refactored -- See case 22439
const VENDOR_LIST_FILTER = {
    Arista: {
        name: "Arista",
        title: "Arista"
    },
    Cisco: {
        name: "Cisco",
        title: "Cisco"
    },
    Extreme: {
        name: "Extreme",
        title: "Extreme"
    },
    F5: {
        name: "F5",
        title: "F5"
    },
    HPE: {
        name: "HPE",
        title: "HPE"
    },
    Juniper: {
        name: "Juniper",
        title: "Juniper"
    },
    Palo: {
        name: "Palo",
        title: "Palo Alto"
    }
    /*
    A10: {
        name: "A10",
        title: "A10"
    },
    Aruba: {
        name: "Aruba",
        title: "Aruba"
    },
    Check: {
        name: "Check",
        title: "Check Point"
    },
    Dell: {
        name: "Dell",
        title: "Dell"
    },
    DellForce: {
        name: "DellForce",
        title: "Dell Force10"
    },
    Riverbed: {
        name: "Riverbed",
        title: "Riverbed"
    },
    Viptela: {
        name: "Viptela",
        title: "Viptela"
    }
*/
};

const FILE_TYPE_FILTER = {
    AES: {
        extension: "aes",
        description: "aes encrypted file",
        "mime-types": []
    },
    BIN: {
        extension: "bin",
        description: "binary archive",
        "mime-types": ["application/octet-stream", "application/x-binary"]
    },
    FLASH: {
        extension: "flash",
        description: "flash file",
        "mime-types": []
    },
    IMG: {
        extension: "img",
        description: "disk image",
        "mime-types": []
    },
    ISO: {
        extension: "iso",
        description: "iso disk image",
        "mime-types": ["application/x-iso9660-image"]
    },
    MD5: {
        extension: "md5",
        description: "md5 encrypted file",
        "mime-types": []
    },
    OUT: {
        extension: "out",
        description: "out file",
        "mime-types": []
    },
    OVA: {
        extension: "ova",
        description: "ovf package",
        "mime-types": []
    },
    PACK: {
        extension: "pack",
        description: "packed jar file",
        "mime-types": []
    },
    PKG: {
        extension: "pkg",
        description: "installer package",
        "mime-types": []
    },
    SHA256: {
        extension: "sha256",
        description: "sha256 encrypted file",
        "mime-types": []
    },
    SPA: {
        extension: "spa",
        description: "spa file",
        "mime-types": []
    },
    SSA: {
        extension: "ssa",
        description: "ssa file",
        "mime-types": []
    },
    TAR: {
        extension: "tar",
        description: "tar archive",
        "mime-types": ["application/tar", "application/x-tar", "multipart/x-tar", "application/x-compress"]
    },
    TGZ: {
        extension: "tgz",
        description: "gzip compressed tar archive",
        "mime-types": ["application/gnutar", "application/x-gtar"]
    },
    ZIP: {
        extension: "zip",
        description: "zip compressed archive",
        "mime-types": ["application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip"]
    }
};

const getFileType = (extension, mimeType) => {
    extension = String(extension).toLocaleLowerCase();
    const typeEntries = Object.entries(FILE_TYPE_FILTER);
    let typeEntry =
        typeEntries.find(([, typeObj]) => typeObj.extension === extension) ||
        typeEntries.find(([, typeObj]) => typeObj["mime-types"].includes(mimeType));

    return typeEntry && typeEntry[0];
};

const isDraft = (status) => OS_IMAGE_STATUS.DRAFT === status;
const isUploaded = (status) => {
    const uploadedStatuses = [OS_IMAGE_STATUS.UPLOADED, OS_IMAGE_STATUS.SYNCING, OS_IMAGE_STATUS.READY];
    return uploadedStatuses.includes(status);
};
const isComplete = (status) =>
    [OS_IMAGE_STATUS.SYNCING, OS_IMAGE_STATUS.READY, OS_IMAGE_STATUS.UPLOADED, OS_IMAGE_STATUS.FAILED, OS_IMAGE_STATUS.ABORTED].includes(status);
const isUploading = (status) => OS_IMAGE_STATUS.UPLOADING === status;

module.exports = {
    IMAGE_TYPES_FILTER,
    VENDOR_LIST_FILTER,
    FILE_TYPE_FILTER,
    getFileType,
    OS_IMAGE_STATUS,
    isDraft,
    isUploading,
    isUploaded,
    isComplete
};
